<template>
  <div class="px-0 pb-0 card-body">
    <div v-if="loading && filteredData.length === 0" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">Loading VSOL EPON ONU data...</p>
    </div>
    <div class="table-responsive" v-else-if="filteredData.length > 0">
      <div class="card mb-4">
        <div class="card-body px-0 pt-0 pb-2 invoice">
          <div class="table-responsive p-0">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Interface
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    ONU ID
                  </th>
                  <th
                    class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                  >
                    PPPOE ID
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    MAC Address
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Distance (m)
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Last Dereg Time
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Dereg Reason
                  </th>
                  <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(data, index) in filteredData" :key="index">
                  <td class="align-middle text-center text-sm">
                    {{ data.interface_name }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ data.onu_interface }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    <span v-if="data.PPPOE_ID === 'Loading...'">
                      <span class="spinner-border spinner-border-sm text-primary" role="status" aria-hidden="true"></span>
                    </span>
                    <span v-else>
                      {{ data.PPPOE_ID ?? 'N/A' }}
                    </span>
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ data.mac_address }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ data.distance }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ formatDateTime(data.last_dereg_time) }}
                  </td>
                  <td class="align-middle text-center text-sm">
                    {{ data.last_dereg_reason }}
                  </td>
                  <td class="text-center">
                    <soft-badge
                      class="p-1 rounded-1 cursor-pointer text-sm"
                      :class="getStatusClass(data.status)"
                      variant="gradient"
                      size="sm"
                    >
                      {{ formatStatus(data.status) }}
                    </soft-badge>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <Skalaton />
    </div>
  </div>
</template>

<script>
import Skalaton from "@/components/Skalaton.vue";

export default {
  name: "VsolEponTable",
  components: {
    Skalaton
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    filteredData: {
      type: Array,
      default: () => []
    },
    sortKey: {
      type: String,
      default: ""
    },
    sortOrder: {
      type: String,
      default: "asc"
    }
  },
  methods: {
    formatDateTime(dateTime) {
      if (!dateTime) return 'N/A';
      return dateTime.replace(' ', ' | ');
    },
    formatStatus(status) {
      if (!status) return 'Unknown';
      return status.charAt(0).toUpperCase() + status.slice(1);
    },
    getStatusClass(status) {
      const statusLower = status ? status.toLowerCase() : '';
      return {
        'bg-warning bg-opacity-50': statusLower === 'offline',
        'bg-danger bg-opacity-25': statusLower === 'disabled',
        'bg-success bg-opacity-25': statusLower === 'online'
      };
    }
  }
};
</script>

<style scoped>
td {
  padding: 12px 24px !important;
}

.sort-icon {
  margin-left: 5px;
  font-size: 0.75rem;
}

.table-responsive {
  overflow-x: auto;
}

.text-sm {
  font-size: 0.875rem !important;
}

.text-xxs {
  font-size: 0.75rem !important;
}

.cursor-pointer {
  cursor: pointer;
}
</style>